import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from '@shared/services/storage.service';
import { UserService } from '@shared/services/user.service';
import { FeatureFlagsAdminController } from './controllers/controller';
import { FeatureFlagsAdminModel } from './model/model';

@Component({
	selector: 'app-featureflags-admin',
	templateUrl: './view/featureflagsadmin.component.html',
	styleUrl: './view/featureflagsadmin.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class FeatureFlagsAdminComponent implements AfterViewInit {
	@ViewChild('networkErrorDialog')
	networkErrorDialog: ElementRef<HTMLDialogElement>;

	@ViewChild('unknownErrorDialog')
	unknownErrorDialog: ElementRef<HTMLDialogElement>;

	@ViewChild('confirmationDialog')
	confirmationDialog: ElementRef<HTMLDialogElement>;

	@ViewChild('addVariantsDialog')
	addVariantsDialog: ElementRef<HTMLDialogElement>;

	@ViewChild('editDateDialog')
	editDateDialog: ElementRef<HTMLDialogElement>;

	public model: FeatureFlagsAdminModel;
	public controller: FeatureFlagsAdminController;
	public constructor(sessionStorageService: SessionStorageService, userService: UserService, httpClient: HttpClient, translator: TranslateService) {
		this.model = new FeatureFlagsAdminModel();
		this.controller = new FeatureFlagsAdminController(sessionStorageService, userService, httpClient, this.model, translator);
	}

	public ngAfterViewInit(): void {
		this.model.confirmationDialog = this.confirmationDialog.nativeElement;
		this.model.unknownErrorDialog = this.unknownErrorDialog.nativeElement;
		this.model.networkErrorDialog = this.networkErrorDialog.nativeElement;
		this.model.editDateDialog = this.editDateDialog.nativeElement;
		this.model.addVariantsDialog = this.addVariantsDialog.nativeElement;
	}
}
